import { Box } from '@mui/material';
import { styled } from '@mui/styles';
import { WsButton, WsTypography, WsTypoVariants } from 'wisestep-base';

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  minWidth: '100%',
}));

type HeaderProps = {
  title: string;
  onClick?: () => void;
  includeBtn: boolean;
  btnText?: string;
};

const HeaderBox = ({ title, onClick, includeBtn, btnText }: HeaderProps) => (
  <StyledBox mb={5}>
    <WsTypography variant={WsTypoVariants.SUB_TITLE}>{title}</WsTypography>

    {includeBtn && btnText && <WsButton onClick={onClick}>{btnText}</WsButton>}
  </StyledBox>
);

export default HeaderBox;
